<template>
  <div class="dialog-wrapper">
    <div class="step">
      <span :style="{ color: step === 'first' || step === 'second' ? '#237FFA' : '' }">
        <a-icon type="cloud-upload" />
        导入文件
      </span>
      <a-icon :style="{ color: step === 'first' || step === 'second' ? '#237FFA' : '' }" type="right" />
      <span :style="{ color: step === 'second' ? '#237FFA' : '' }">
        <a-icon type="file-exclamation" />
        数据校验
      </span>
      <a-icon :style="{ color: step === 'second' ? '#237FFA' : '' }" type="right" />
      <span>
        <a-icon type="export" />
        导入系统
      </span>
    </div>
    <div class="wrapper">
      <span class="title">一、请按照数据模板的格式准备要导入的数据</span>
      <a class="download" @click="downloadModel">点击下载数据模板</a>
      <br />
      <span class="desc">导入数据请勿超过{{ limit }}条，超过{{ limit }}条数据请分批导入。</span>
    </div>
    <div class="wrapper">
      <div class="subWrapper">
        <span class="title">二、请选择要导入的文件，进行数据校验</span>
        <a-upload :disabled="loading" :showUploadList="false" :beforeUpload="handleExcel" :accept="accept">
          <a :class="['iconWrapper', loading ? 'loading' : '']">
            <a-icon :type="loading ? 'loading' : 'upload'" />
            导入文件
          </a>
        </a-upload>
        <a v-if="total" :class="['iconWrapper', checkLoading ? 'loading' : '']" @click="checkData">
          <a-icon :type="checkLoading ? 'loading' : 'file-exclamation'" />
          数据校验
        </a>
        <div v-if="total" class="process">
          <span>校验完成：{{ successNum }}条/{{ total }}条</span>
          <a-progress :percent="percent" size="small" />
        </div>
      </div>
      <a-alert v-if="total && successNum === total" type="success" message="数据校验成功，可直接导入系统" banner />
      <a-alert
        v-if="errorNum"
        :message="`数据校验结果：当前有${errorNum}条数据不符合系统规范，请先调整红色标示内容后再进行导入`"
        banner
      />
    </div>
    <div class="choices">
      <div>
        <a-button type="primary" @click="newData">新增行</a-button>
        <a-button type="primary" :disabled="!selectedKeys.length" @click="batchAddDevice">批量录入</a-button>
        <a-popconfirm
          :disabled="!selectedKeys.length"
          placement="leftTop"
          ok-text="确认"
          cancel-text="取消"
          @confirm="handleBatchDelete"
        >
          <template slot="title">确认删除？</template>
          <a-button :disabled="!selectedKeys.length">批量删除</a-button>
        </a-popconfirm>
        <a-popconfirm
          :disabled="!selectedKeys.length"
          placement="leftTop"
          ok-text="确认"
          cancel-text="取消"
          @confirm="handleEmpty"
        >
          <template slot="title">确认清空？</template>
          <a-button :disabled="!selectedKeys.length">清空</a-button>
        </a-popconfirm>
      </div>
      <div>
        <span style="margin-right: 2em">
          共&ensp;
          <span style="color: #237ffa">{{ total }}</span>
          &ensp;条
        </span>
        <a-checkbox v-model="onlyError">仅显示校验错误数据</a-checkbox>
      </div>
    </div>
    <a-spin :spinning="loading" tip="数据导入中" size="large">
      <a-form-model ref="excel" :model="excelForm">
        <xz-table
          ref="table"
          :enableRowSelection="true"
          :selectionType="'checkbox'"
          :columns="excelColumns"
          :data="excelForm.excelData"
          :scroll="{ x: '100%', y: 400 }"
          @change="handleChange"
          rowKey="_id"
        >
          <span v-for="e in eSlots" :slot="e.key" slot-scope="text, record, index" :key="e.key">
            <a-form-model-item
              :prop="'excelData.' + index + '.' + e.key"
              style="margin-bottom: 0"
              :rules="e.setRules ? e.setRules(record) : e.rules || []"
            >
              <div style="display: flex; align-items: center">
                <a-input
                  v-if="e._type === 'input'"
                  v-model="record[e.key]"
                  :placeholder="`请输入${e.title}`"
                  :style="{ width: e.inputWidth }"
                />
                <a-date-picker
                  v-if="e._type === 'date'"
                  v-model="record[e.key]"
                  valueFormat="x"
                  style="width: 100%"
                  allow-clear
                ></a-date-picker>
                <a-input-number
                  v-if="e._type === 'number'"
                  v-model="record[e.key]"
                  :min="e.min"
                  :step="e.step"
                  :precision="e.precision"
                  :placeholder="`请输入${e.title}`"
                />
                <a-select
                  v-if="e._type === 'select'"
                  v-model="record[e.key]"
                  :placeholder="`请选择${e.title}`"
                  @change="v => e.handleChange(v, record)"
                >
                  <a-select-option v-for="opt in e._options" :key="opt.value" :value="opt.value">
                    {{ opt.label }}
                  </a-select-option>
                </a-select>
                <template v-if="e.subs">
                  <div v-for="child in e.subs" :key="child.key" :style="{ width: child.width, marginLeft: '8px' }">
                    <a-select
                      v-if="child._type === 'select'"
                      v-model="record[child.key]"
                      :placeholder="`请选择${child.title}`"
                    >
                      <a-select-option v-for="opt in child._options" :key="opt.value" :value="opt.value">
                        {{ opt.label }}
                      </a-select-option>
                    </a-select>
                  </div>
                </template>
              </div>
            </a-form-model-item>
          </span>
          <span slot="action" slot-scope="text, record, index">
            <a-popconfirm placement="leftTop" ok-text="确认" cancel-text="取消" @confirm="handleDelete(index)">
              <template slot="title">确认删除？</template>
              <a style="color: #f56c6c">删除</a>
            </a-popconfirm>
          </span>
        </xz-table>
      </a-form-model>
    </a-spin>
    <div class="button-group">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" :disabled="!excelForm.excelData.length" @click="confirmExcelData">确定</a-button>
    </div>
    <a-modal
      v-model="isBatchImport"
      title="批量录入"
      :width="430"
      :bodyStyle="{ padding: '6px 12px' }"
      :maskClosable="false"
      :destroyOnClose="true"
      :footer="null"
    >
      <batch-import
        :config="config"
        @cancel="() => (isBatchImport = false)"
        @confirm="handleBatchImportConfirm"
      ></batch-import>
    </a-modal>
  </div>
</template>

<script>
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
import excel from '@/utils/excel.js';
import _ from 'lodash';
import dayjs from 'dayjs';
import BatchImport from '@/components/batchImport/index.vue';

export default {
  name: 'ExcelHandle',
  props: {
    limit: {
      type: Number,
      default: 300,
    },
    config: {
      type: Array,
      default: () => [],
    },
    downloadUrl: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    xzTable,
    BatchImport,
  },
  computed: {
    excelColumns () {
      const cols = [...this.config];

      cols.push({
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        fixed: 'right',
        width: 60,
        scopedSlots: { customRender: 'action' },
      });

      return cols;
    },
    keys () {
      const keys = [];

      this.config.forEach(c => {
        keys.push({ key: c.key, type: c._type, default: c.default });

        if (c.subs) {
          c.subs.forEach(child => {
            keys.push({ key: child.key, type: child._type, default: child.default });
          });
        }
      });

      return keys;
    },
    eSlots () {
      const slots = this.config.filter(c => c.scopedSlots);

      return slots;
    },
    total () {
      return this.excelForm.excelData.length;
    },
    requiredKeys () {
      return this.config.filter(v => v.rules || v.setRules).map(v => ({ key: v.key, setRules: v.setRules, type: v._type }));
    },
  },
  watch: {
    onlyError (newV) {
      if (newV) {
        this.excelForm.excelData = this.tableData.filter(e => {
          return !this.validate(e);
        });
      } else {
        this.excelForm.excelData = this.tableData;
      }
    },
  },
  data () {
    return {
      step: 'first',
      errorNum: 0,
      successNum: 0,
      tableData: [],
      excelForm: {
        excelData: [],
      },
      accept: '.xls,.xlsx',
      percent: 0,
      checkLoading: false,
      onlyError: false,
      selectedKeys: [],
      loading: false,
      confirmExcelData: _.throttle(this.handleConfirm, 50),
      isBatchImport: false,
    };
  },
  methods: {
    downloadModel () {
      var xhr = new XMLHttpRequest();
      xhr.open('get', this.downloadUrl.url);
      xhr.responseType = 'blob';
      xhr.onload = () => {
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(xhr.response);
        link.target = '_blank';
        link.download = this.downloadUrl.name;
        link.click();
        link.remove();
      };
      xhr.send();
    },
    formatDate (numb) {
      let getDay = numb - 1;
      let t = Math.round((getDay - Math.floor(getDay)) * 24 * 60 * 60);

      return new Date(1900, 0, getDay, 0, 0, t);
    },
    handleExcel (file) {
      try {
        this.loading = true;

        let reader = new FileReader();

        reader.readAsArrayBuffer(file);

        reader.onload = e => {
          const data = e.target.result;
          const titles = [];
          let isError = false;

          const { header = [], results = [] } = excel.read(data, { type: 'array' });

          // excel的第一行会被解析为表头，过滤超出列数的单元格描述
          header.splice(this.keys.length);

          this.config.forEach(con => {
            titles.push(con.title);

            if (con.subs) {
              con.subs.forEach(sub => {
                titles.push(sub.title);
              });
            }
          });

          for (const k in titles) {
            if (!header[k].includes(titles[k])) {
              isError = true;
              break;
            }
          }

          if (isError) {
            this.$message.error('上传模板错误！');
            this.loading = false;
            return false;
          }

          if (!results.length) {
            this.$message.warning('模板无数据！');
            this.loading = false;
            return false;
          }

          const tableData = results.map(r => {
            const o = {
              _id: _.uniqueId(),
            };

            header.forEach((k, index) => {
              if (this.keys[index].type === 'date') {
                console.log(r[k], dayjs(r[k]).valueOf());
                o[this.keys[index].key] = r[k] ? dayjs(this.formatDate(r[k])).valueOf() + '' : '';
              } else {
                o[this.keys[index].key] = r[k];
              }
            });

            return o;
          });

          this.tableData = [...tableData, ...this.tableData];

          if (this.onlyError) {
            this.excelForm.excelData = this.tableData.filter(e => {
              return !this.validate(e);
            });
          } else {
            this.excelForm.excelData = this.tableData;
          }

          this.errorNum = 0;
          this.successNum = 0;
          this.percent = 0;

          this.loading = false;
        };
      } catch (error) {
        this.loading = false;
      }
    },
    handleDelete (index) {
      const _id = this.excelForm.excelData[index]._id;

      this.excelForm.excelData.splice(index, 1);

      const tIndex = this.tableData.findIndex(t => t._id === _id);

      if (tIndex !== -1) {
        this.tableData.splice(tIndex, 1);
      }

      if (this.selectedKeys.includes(_id)) {
        const index = this.selectedKeys.findIndex(id => id === _id);

        this.selectedKeys.splice(index, 1);
      }
    },
    validate (v) {
      let ret = true;

      this.requiredKeys.forEach(k => {
        let isRequired = true;

        if (k.setRules) {
          const res = k.setRules(v);

          isRequired = res[0].required;
        }
        if (k.type === 'number' && v[v.key] !== undefined && v[v.key] !== '' && v[v.key] !== null) {
          ret &&= (parseFloat(v[k.key]) && Number(v[k.key]) && Number(v[k.key]) > 0);
        }

        if (isRequired) {
          ret &&= !!v[k.key];
        }
      });

      return ret;
    },
    checkData () {
      if (this.checkLoading) {
        return false;
      }

      this.checkLoading = true;

      try {
        let errorNum = 0;
        let successNum = 0;

        this.excelForm.excelData.forEach((e, i) => {
          this.validate(e) ? successNum++ : errorNum++;

          this.percent = Math.ceil(((i + 1) / this.total) * 100);
        });

        this.errorNum = errorNum;
        this.successNum = successNum;

        this.$refs.excel.validate(valid => {
          this.checkLoading = false;

          if (!valid) {
            return false;
          }

          this.step = 'second';
        });
      } catch (e) {
        this.checkLoading = false;
      }
    },
    handleCancel () {
      this.$emit('cancel');
    },
    handleConfirm () {
      this.$refs.excel.validate(valid => {
        if (!valid) {
          return false;
        }

        this.$emit('confirm', this.tableData);
      });
    },
    handleChange (_ids) {
      this.selectedKeys = _ids;
    },
    handleBatchDelete () {
      const filteredExcelData = this.excelForm.excelData.filter(i => !this.selectedKeys.includes(i._id));

      this.excelForm.excelData = filteredExcelData;

      const filteredTableData = this.tableData.filter(i => !this.selectedKeys.includes(i._id));
      this.tableData = filteredTableData;

      this.selectedKeys = [];
    },
    handleEmpty () {
      this.tableData = [];
      this.excelForm.excelData = [];
      this.selectedKeys = [];
    },
    newData () {
      const data = {
        _id: _.uniqueId(),
      };

      this.keys.forEach(k => {
        data[k.key] = k.default;
      });

      this.excelForm.excelData.push(data);

      if (this.tableData.findIndex(t => t._id === data._id) === -1) {
        this.tableData.push(data);
      }
    },
    batchAddDevice () {
      this.isBatchImport = true;
    },
    handleBatchImportConfirm (v) {
      const selectedData = this.excelForm.excelData.filter(d => this.selectedKeys.includes(d._id));

      for (const k in v) {
        selectedData.forEach(selected => {
          selected[k] = v[k];
        });
      }

      this.isBatchImport = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-wrapper {
  position: relative;
  height: 763px;
}

.step {
  width: 100%;
  background: #f2f4f7;
  height: 46px;
  line-height: 46px;

  span {
    display: inline-block;
    width: 30%;
    text-align: center;

    .anticon {
      margin-right: 2px;
    }
  }
}

.button-group {
  width: 100%;
  padding: 10px 16px;
  text-align: right;
  background: transparent;
  border-top: 1px solid #e8e8e8;
  border-radius: 0 0 4px 4px;
  position: absolute;
  bottom: 0;
  right: 0;
  .ant-btn:first-of-type {
    margin-right: 12px;
  }
}

.title {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  margin-right: 0.5em;
}

.wrapper {
  margin-top: 12px;

  .subWrapper {
    display: flex;
    align-items: center;
    line-height: 16px;
  }

  .desc {
    display: inline-block;
    text-indent: 2em;
    color: #929aa6;
  }

  .process {
    display: inline-block;

    span {
      font-size: 10px;
      color: #929aa6;
    }
  }

  .iconWrapper {
    display: inline-block;
    padding: 4px;
    background: #e2f3fe;
    border-radius: 2px;
    font-size: 12px;
    color: #237ffa;
    margin-right: 1em;

    &.loading {
      opacity: 0.6;
    }

    &:hover {
      opacity: 0.8;
    }

    .anticon {
      margin-right: 2px;
    }
  }
}

.choices {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1em;

  button {
    margin-right: 1em;
  }
}

/deep/ .ant-form-explain {
  display: none;
}

/deep/ .ant-table-body {
  content-visibility: auto;
}
</style>
